import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SignupButton } from 'purchase-motions-components/components/PurchaseMotions/SignupButton/SignupButton';
import { isPublicPurchaseMotion } from 'purchase-motions-components/utils/purchaseMotionTypeGuards';
import { PublicPurchaseMotionCTAWrapper } from '../../components/PublicPurchaseMotionCTAWrapper';
import { HSOC_V2_SCREEN, TRACKING_SOURCES, trackHsocSignupButtonClick } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Narrows the tier's purchaseMotions to the public-renderable subset.
 * isPublicPurchaseMotion excludes in-app-only motions and unhandledEnumCase
 * values, matching the normal public merch card CTAs (PublicMerchCardCTAs).
 */
function getPublicHsocMotions(motions) {
  return motions.filter(isPublicPurchaseMotion);
}

/*
 * Public HSOC V2 merch card CTA cluster. Mirrors the normal public merch card
 * CTAs (PublicMerchCardCTAs): the FREE tier gets a "Get started free" signup
 * button, and every other tier maps its purchaseMotions to the shared
 * PublicPurchaseMotionCTAWrapper.
 */
export const PublicHsocMerchCardCTAs = ({
  tierName,
  productApiName,
  motions,
  currencyCode,
  term
}) => {
  const isFree = tierName === 'FREE';
  const publicMotions = getPublicHsocMotions(motions);
  if (publicMotions.length === 0 && !isFree) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    inlineSize: "100%",
    children: [isFree && /*#__PURE__*/_jsx(SignupButton, {
      apiName: productApiName,
      trackingData: {
        app: 'pricing-pages',
        source: TRACKING_SOURCES.MERCH_CARD,
        screen: HSOC_V2_SCREEN,
        uniqueId: `merch-card-${productApiName}`
      }
      /* TODO(#21701): audit this signup-click tracking as part of the
       * HSOC V2 usage-tracking review. */,
      onClick: () => trackHsocSignupButtonClick({
        trackingSource: TRACKING_SOURCES.MERCH_CARD,
        productNames: [productApiName]
      }),
      uiButtonProps: {
        use: 'primary',
        block: true
      },
      "data-selenium-id": "free-signup-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.cta.getStartedFree"
      })
    }), publicMotions.map((motion, index) => /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(PublicPurchaseMotionCTAWrapper, {
        purchaseMotion: motion,
        productApiName: productApiName,
        currencyCode: currencyCode,
        paymentTerm: term,
        commitmentTerm: term,
        displayIndex: isFree ? index + 1 : index,
        trackingData: {
          app: 'pricing-pages',
          source: TRACKING_SOURCES.MERCH_CARD,
          screen: HSOC_V2_SCREEN,
          uniqueId: `merch-card-${productApiName}`
        }
      })
    }, motion))]
  });
};